<template>
  <div>
    <div class="title-h4 mr-b10">조건 설정</div>
    <el-form :model="alarmData" label-position="top" ref="alarmForm" :rules="rules">
      <el-form-item label="필터" prop="eventValue">
        <el-select v-model="alarmData.eventValue" @change="changeBaseLineFilter">
          <el-option
            v-for="item in baseLineFilterData"
            :key="item.filterId"
            :label="item.filterName"
            :value="item.filterId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="베이스라인 정보" prop="baseLineInfo"></el-form-item>
      <div class="list form-list mr-b25">
        <el-form>
          <el-form-item label="통계기간" label-width="120px">{{getValueAfterCheckEmpty(baseLineFilterInfo.statsPeriod)}}개월</el-form-item>
          <el-form-item label="상한" label-width="120px">+{{getValueAfterCheckEmpty(baseLineFilterInfo.upperBound)}}%</el-form-item>
          <el-form-item label="하한" label-width="120px">-{{getValueAfterCheckEmpty(baseLineFilterInfo.lowerBound)}}%</el-form-item>
          <el-form-item label="평균" label-width="120px">{{getValueAfterCheckEmpty(baseLineFilterInfo.logAvg)}}개</el-form-item>
          <el-form-item label="총" label-width="120px">{{getValueAfterCheckEmpty(baseLineFilterInfo.total)}}개</el-form-item>
        </el-form>
      </div>
      <el-row type="flex" justify="space-between" class="mr-b10 vertical-center-box">
        <div class="title-h4">이벤트 등급</div>
        <el-button type="primary" @click="addEventlevelSetting">등급 추가</el-button>
      </el-row>
      <el-table-wrapper :column-default="columnDefault" border :data="eventlevelData" :columns="baseLineColumns" :pagination="false"
        :show-custom-header="false" header-align="center" highlight-current-row>
        <template slot-scope="scope" slot="eventlevelId-slot">
          <el-select v-model="scope.row.eventlevelId" @change="checkValidEventlevel(eventlevelData, scope.row.eventlevelId)">
            <el-option
              v-for="item in eventlevelSetting"
              :key="item.eventlevelId"
              :label="item.eventlevelName"
              :value="item.eventlevelId">
            </el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="eventThreshold-slot">
          <el-row>
              <el-input type="Number" v-model="scope.row.eventThreshold" suffix-icon="fas fa-percent" min="1"></el-input>
          </el-row>
        </template>
        <template slot-scope="scope" slot="eventcheckTime-slot">
          <el-row>
            <el-col :span="13">
              <el-input type="Number" v-model="scope.row.eventcheckTime" min="1"></el-input>
            </el-col>
            <el-col :span="11">
              <el-select v-model="scope.row.eventcheckTimeUnit">
                <el-option
                  v-for="item in timeSetting"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </template>
        <template slot-scope="scope" slot="delete-row-slot">
          <span class="c-pointer" v-if="scope.$index !== 0" @click="deleteEventRow(scope, scope.$index)"><i class="fal fa-times"></i></span>
        </template>
      </el-table-wrapper>
    </el-form>
  </div>
</template>

<script>
import { isEmpty, isNil } from 'lodash';
import { columnDefault } from '@/constants/table';
import AlarmAPI from '@/api/settings/log/lms-alarm-setting';
import msgUtil from '@/utils/message';
import { getValueAfterCheckEmpty } from '@/utils/string';
import AlarmSettingMixins from '../js/alarm-setting-mixins';

export default {
  name: 'WAlarmBaseLineSetting',
  mixins: [AlarmSettingMixins],
  props: {
    alarmData: {
      type: Object,
    },
    eventlevelData: {
      type: Array,
    },
    eventlevelSetting: {
      type: Array,
    },
    isAdd: {
      type: Boolean,
    },
  },
  data() {
    const baseLineColumns = [
      {
        label: '이벤트 등급',
        prop: 'eventlevelId',
        width: '130px',
        scopedSlot: 'eventlevelId-slot',
      },
      {
        label: '상한 초과율',
        prop: 'eventThreshold',
        scopedSlot: 'eventThreshold-slot',
      },
      {
        label: '판단 주기',
        prop: 'eventcheckTime',
        width: '150px',
        scopedSlot: 'eventcheckTime-slot',
      },
      {
        width: '50px',
        align: 'center',
        scopedSlot: 'delete-row-slot',
      },
    ];
    return {
      columnDefault,
      baseLineColumns,
      baseLineFilterData: [],
      baseLineFilterInfo: {}, // API로 데이터를 받았을 때 설정해주도록 한다
      timeSetting: [
        { value: 'S', label: '초' },
        { value: 'M', label: '분' },
        { value: 'H', label: '시' },
        { value: 'D', label: '일' },
      ],
      rules: {
        eventValue: [
          { required: true, message: '필수 정보입니다.', trigger: 'change' },
        ],
      },
      checkDuplicateEventlevel: false,
    };
  },
  methods: {
    getValueAfterCheckEmpty,
    /**
     * 베이스라인 데이터 로드 함수
     * @author leesy918
     * @return {[type]} [description]
     */
    loadData() {
      AlarmAPI.getAlarmBaseline().then((response) => {
        if (response.data.success) {
          if (!isEmpty(response.data.data)) {
            this.baseLineFilterData = response.data.data;
            this.$nextTick(() => {
              this.alarmData.eventCondition = 'baseLineFilter';
              this.alarmData.eventConditionLabel = '베이스라인 필터';
              if (this.isAdd) {
                this.alarmData.eventValue = this.baseLineFilterData[0].filterId;
                this.addEventlevelSetting();
              } else {
                const filterData = this.baseLineFilterData.find((item) => item.filterId === Number(this.alarmData.eventValue));
                this.alarmData.eventValue = filterData.filterId;
              }
              this.loadFilterInfo();
            });
          } else {
            this.$message(msgUtil.getCustomMsgData('필터를 먼저 추가해주세요.'));
          }
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '필터 목록', false));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '필터 목록', false));
        throw new Error(e);
      });
    },
    checkValidation() {
      let checkEvent = true;
      let checkValidation = false;

      this.$refs.alarmForm.validate().then((success) => {
        if (success) {
          checkValidation = true;

          this.eventlevelData.forEach((item) => {
            if (isNil(item.eventThreshold) || isNil(item.eventcheckTime) || item.eventThreshold <= 0 || item.eventcheckTime <= 0) {
              checkEvent = false;
            }
          });
          if (checkEvent && checkValidation && !this.checkDuplicateEventlevel) {
            this.$emit('increaseActiveStep');
          } else {
            this.$message(msgUtil.getCustomMsgData('이벤트 값이 잘못되었습니다'));
          }
        }
      }).catch(() => {});
    },
    /**
     * 콤보 박스 선택 시 필터의 정보 조회
     * @author leesy918
     * @return {[type]} [description]
     */
    loadFilterInfo() {
      const params = {
        filterId: this.alarmData.eventValue,
      };
      AlarmAPI.getAlarmFilterInfo(params).then((response) => {
        if (response.data.success) {
          this.baseLineFilterInfo = response.data.data[0];
          this.alarmData.eventLabel = response.data.data[0].filterName;
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '필터 정보', false));
        throw new Error(e);
      });
    },
    /**
     * 데이터 베이스 이벤트 제거 함수
     * @author leesy918
     * @param  {[type]} scope [description]
     * @return {[type]}       [description]
     */
    deleteEventRow(scope, index) {
      this.$emit('deleteEventRow', scope, index);
      this.checkValidEventlevel(this.eventlevelData, scope.row.eventlevelId);
    },
    /**
     * 데이터 베이스 이벤트 추가 함수
     * @author leesy918
     */
    addEventlevelSetting() {
      const addData = {
        eventlevelId: this.eventlevelSetting[0].eventlevelId,
        eventThreshold: 1,
        eventcheckTimeUnit: this.timeSetting[0].value,
        eventcheckTime: 1,
      };
      this.eventlevelData.push(addData);
      this.checkValidEventlevel(this.eventlevelData, this.eventlevelSetting[0].eventlevelId);
    },
    /**
     * 베이스 라인 필터 변경 함수
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    changeBaseLineFilter() {
      this.loadFilterInfo();
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Alarm/popup/components/AlarmBaseLineSetting.vue